/** Días de la semana en la grilla de agenda (local hasta API VisitasAgenda). */
export type VisitasAgendaDiaKey = 'lun' | 'mar' | 'mier' | 'jue' | 'vie' | 'sab' | 'dom';

export type VisitasAgendaDias = Record<VisitasAgendaDiaKey, boolean>;

export const VISITAS_AGENDA_DIA_KEYS: VisitasAgendaDiaKey[] = [
  'lun',
  'mar',
  'mier',
  'jue',
  'vie',
  'sab',
  'dom',
];

export const VISITAS_AGENDA_DIA_LABELS: Record<VisitasAgendaDiaKey, string> = {
  lun: 'Lunes',
  mar: 'Martes',
  mier: 'Miércoles',
  jue: 'Jueves',
  vie: 'Viernes',
  sab: 'Sábado',
  dom: 'Domingo',
};

export const emptyVisitasAgendaDias = (): VisitasAgendaDias => ({
  lun: false,
  mar: false,
  mier: false,
  jue: false,
  vie: false,
  sab: false,
  dom: false,
});

/** Quita solo el código de dirección del nombre; conserva la calle/dirección. */
export const stripDireccionFromAgendaNombre = (
  nombreDisplay: string,
  codigoDireccion?: string | null,
): string => {
  const nombre = nombreDisplay.trim();
  const cod = (codigoDireccion ?? '').trim();
  if (!nombre || !cod) return nombre;

  const escaped = cod.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  return nombre
    .replace(new RegExp(`\\s*[—–-]\\s*${escaped}(?=\\s*[—–-])`, 'i'), '')
    .replace(new RegExp(`\\s*[—–-]\\s*${escaped}\\s*$`, 'i'), '')
    .replace(/\s*[—–-]\s*[—–-]/g, ' — ')
    .replace(/\s{2,}/g, ' ')
    .trim();
};

export interface VisitasAgendaFila {
  /** Id local o futuro idVisitasAgenda de API */
  idVisitasAgenda: string;
  nroCliente: number;
  codigoDireccion?: string;
  nombreDisplay: string;
  dias: VisitasAgendaDias;
  /** Enriquecidos desde Cliente / dirección (no se persisten en agenda). */
  nroVendedor?: number | null;
  nombreVendedor?: string | null;
  codigoRuta?: number | null;
  nombreRuta?: string | null;
  codigoCiudad?: number | null;
  nombreCiudad?: string | null;
}

export interface VisitasAgendaNamed {
  id: string;
  nombre: string;
  filas: VisitasAgendaFila[];
  updatedAt: string;
}

export interface VisitasAgendaStore {
  activeAgendaId: string;
  agendas: VisitasAgendaNamed[];
}

export interface VisitasAgendaAutocompletarPreview {
  totalDias: number;
  totalVisitasNuevas: number;
  porDia: Array<{
    fecha: string;
    visitasNuevas: number;
    planExistente: boolean;
    planNuevo?: boolean;
    conflicto409?: boolean;
  }>;
}

export interface GenerarVisitasPlanResult {
  modo: string;
  totalDias: number;
  totalVisitasNuevas: number;
  planesCreados: number;
  visitasAgregadas: number;
  diasOmitidosPorConflicto: string[];
  porDia: Array<{
    fecha: string;
    visitasNuevas: number;
    planExistente: boolean;
    planNuevo: boolean;
    conflicto409: boolean;
  }>;
}

export interface VisitasAgendaCandidato {
  nroCliente: number;
  codigoDireccion?: string | null;
  nombreDisplay?: string | null;
  lunes: boolean;
  martes: boolean;
  miercoles: boolean;
  jueves: boolean;
  viernes: boolean;
  sabado: boolean;
  domingo: boolean;
}
